<template>
  <div class="class_recod_list">
    <van-list
      class="bgwhite"
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <record-panel
        class="bgwhite"
        v-for="(item, index) in list"
        :key="index"
        :record="item"
        :has-more="item.is_owner"
        @delete="onDelete"
      />
    </van-list>
  </div>
</template>

<script>
import { List } from 'vant'
import RecordPanel from '@/views/record/components/RecordPanel'
import { userRecordList } from '@/api/record'

export default {
  name: 'ClassRecodList',
  components: {
    [List.name]: List,
    RecordPanel
  },
  props: {
    clazzId: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        user: '',
        clazz: '',
        status: 1,
        page: 0,
        size: 8
      }
    }
  },
  methods: {
    async getRecordList () {
      this.loading = true
      this.listQuery.clazz = this.clazzId
      let response = await userRecordList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    },
    onLoad () {
      this.listQuery.page += 1
      this.getRecordList()
    },
    onDelete () {
      this.listQuery.page = 0
      this.list = []
      this.onLoad()
      this.$emit('delete')
    }
  }
}
</script>
